var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 2.5,
    rx: 1.25,
    transform: "translate(0 8.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.222,
    height: 2.5,
    rx: 1.25,
    transform: "translate(5.778 17.5)"
  }))));
}
export default SvgBurgerMenu;